import script from "./invoiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./invoiceModal.vue?vue&type=script&setup=true&lang=js"

import "./invoiceModal.vue?vue&type=style&index=0&id=1485d28d&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1485d28d"]])

export default __exports__